/* tslint:disable:jsx-no-multiline-js */
import 'rmc-picker/assets/index.css'
import 'rmc-date-picker/assets/index.css';
import 'rmc-picker/assets/popup.css'
import './styles/index.css'
import * as PropTypes from 'prop-types'
import * as React from 'react'
import RCDatePicker from 'rmc-date-picker/lib/DatePicker'
import PopupDatePicker from 'rmc-date-picker/lib/Popup'
import { DatePickerPropsType } from './PropsType'
import { bridge } from './bridge'
import { formatFn } from './utils'
import zh_Cn from './locale/zh_CN'

export interface PropsType extends DatePickerPropsType {
  prefixCls?: string
  className?: string
  use12Hours?: boolean
  pickerPrefixCls?: string
  popupPrefixCls?: string
  onOk?: (x: any) => void
  onchange?: (v: any) => void
  onVisibleChange?: (visible: boolean) => void
}

interface DatePickerState {
  isShowDatePicker: boolean,
  userInsertConfig: DatePickerPropsType
}

export default class DatePicker extends React.Component<PropsType, DatePickerState> {
  private popupDatePicker_wrapComponent: React.RefObject<HTMLDivElement>
  constructor(props: DatePickerPropsType) {
    super(props)
    this.popupDatePicker_wrapComponent = React.createRef()
  }
  static defaultProps = {
    mode: 'datetime',
    minuteStep: 1,
    use12Hours: false,
  }


  static contextTypes = {
    antLocale: PropTypes.object,
  }

  public state = {
    isShowDatePicker: false,
    userInsertConfig: {
      mode: 'datetime',
      onChange: (v: any) => {
        console.log(v)
      }
    }
  }

  private scrollValue: any

  public componentDidMount() {
    bridge.setConfig = (config) => {
      this.setState({
        isShowDatePicker: true,
        userInsertConfig: config
      }, () => {
        if (this.popupDatePicker_wrapComponent) {
          const ele = this.popupDatePicker_wrapComponent.current
          if (ele) {
            ele.click()
          }
        }
      })
    }
    document.addEventListener('click', this.listenPickerClick.bind(this))
  }

  public componentWillUnmount() {
    document.removeEventListener('click', this.listenPickerClick.bind(this))
  }

  findTagElement = () => {
    const reg = /^rmc-picker-popup-container-/
    const tags = document.getElementsByTagName('*')  
    const tagsArr = []
    for (let i= 0; i < tags.length; i++) {  
         if (tags[i].tagName === 'DIV' && reg.test(tags[i].id)) {
            tagsArr.push(tags[i])
        }
    }
    return tagsArr[0]
  }

  public listenPickerClick() {
     if (document.querySelector('.rmc-picker-popup-header-left')) {
      (document as any).querySelector('.rmc-picker-popup-header-left').addEventListener('click', (e: Event) => {
        e.stopPropagation()
        this.hidePicker()
      })
     }

     if (document.querySelector('.rmc-picker-popup-header-right')) {
      (document as any).querySelector('.rmc-picker-popup-header-right').addEventListener('click', (e: Event) => {
        e.stopPropagation();
        this.hidePicker();
        (this.scrollValue) ? this.onOk(this.scrollValue) : this.onOk(this.props.value)
      })
     }

     if (document.querySelector('.rmc-picker-popup-wrap')) {
      (document as any).querySelector('.rmc-picker-popup-wrap').addEventListener('click', (e: Event) => {
        e.stopPropagation()
        this.hidePicker()
      })
     }

    if (document.querySelector('.rmc-picker-popup-content')) {
      (document as any).querySelector('.rmc-picker-popup-content').addEventListener('click', (e: Event) => {
        e.stopPropagation()
      })
     }
  }

  hidePicker = () => {
    if ((document as any).querySelector('.rmc-picker-popup-wrap')) {
        const mask =  (document as any).querySelector('.rmc-picker-popup-mask')
        const ele = (document as any).querySelector('.rmc-picker-popup-wrap')
        ele.classList.add('am-slide-up-leave', 'am-slide-up-leave-active');
        mask.classList.add('am-fade-leave-active', 'am-fade-leave')
        ele.addEventListener('webkitAnimationEnd', () => {
          const getPickerRootElement = this.findTagElement();
          if (getPickerRootElement) {
            (getPickerRootElement as any).style.display = 'none';
          }
          if (document.querySelector('.DatePicker_Children_Special')) {
            (document as any).querySelector('.DatePicker_Children_Special').click()
          }
          document.body.removeAttribute("style")
        })
    }
  }

  setScrollValue = (v: any) => {
    this.scrollValue = v
    const {mode} = this.state.userInsertConfig
    if (document.querySelector('.popTitle')) {
      (document as any).querySelector('.popTitle').innerHTML = this.renderModeShowFormat(mode, v)
    }
  }

  renderModeShowFormat = (mode: string, date: Date) => {
    switch(mode) {
      case 'datetime':
        return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日${date.getHours()}时${date.getMinutes()}分`
      case 'date':
        return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`
      case 'time':
        return `${date.getHours()}时${date.getMinutes()}分`
      case 'month':
        return `${date.getFullYear()}年${date.getMonth() + 1}月`
      case 'year':
        return `${date.getFullYear()}年`
      default:
        return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日${date.getHours()}时${date.getMinutes()}分`
    }
  }

  onOk = (v: any) => {
    if (this.scrollValue !== undefined) {
      v = this.scrollValue
    }
    if (this.state.userInsertConfig && this.state.userInsertConfig.onChange) {
         this.state.userInsertConfig.onChange(v)
    }
    if (this.props.onOk) {
      this.props.onOk(v)
    }
  }

  onVisibleChange = (visible: boolean) => {
    this.scrollValue = undefined
    if (visible === false) {
       this.setState({
          isShowDatePicker: false
       })
    }
    if (this.props.onVisibleChange) {
      this.props.onVisibleChange(visible)
    }
  }

  fixOnOk = (picker: any) => {
    if (picker) {
      picker.onOk = this.onOk
    }
  }

  renderPopPickerTitleWrap = () => {
    const {mode} = this.state.userInsertConfig
    return (
      <div>
          <div className="popPickerwrap_line"></div>
          <div className="popTitle">{ this.props.value ? this.renderModeShowFormat(mode, this.props.value) : this.renderModeShowFormat(mode, new Date()) }</div>
      </div>
    )
  }

  renderOkBtn = () => {
    return (
      <div className="datePicker-left-btn">确定</div>
    )
  }

  renderCancelBtn = () => {
    return (
      <div className="datePicker-right-btn">取消</div>
    )
  }

  render() {
    if (!this.state.isShowDatePicker) {
      return null
    }
    // tslint:disable-next-line:no-this-assignment
    const { props } = this
    const { children, value } = props
    const {userInsertConfig} = this.state
    const locale = zh_Cn
    const { extra, DatePickerLocale } = locale

    const datePicker = (
      <RCDatePicker
        minuteStep={props.minuteStep}
        locale={DatePickerLocale}
        minDate={props.minDate}
        maxDate={props.maxDate}
        mode={props.mode}
        defaultDate={value || new Date()}
        use12Hours={props.use12Hours}
        onValueChange={props.onValueChange}
        onScrollChange={this.setScrollValue}
        {...userInsertConfig}
      />
    )

    return (
          <PopupDatePicker
            datePicker={datePicker}
            WrapComponent="div"
            transitionName="rmc-picker-popup-slide-fade"
            maskTransitionName="rmc-picker-popup-fade"
            {...props as any}
            date={value || new Date()}
            dismissText={this.props.dismissText || this.renderCancelBtn()}
            okText={this.props.okText || this.renderOkBtn()}
            title ={this.renderPopPickerTitleWrap()}
            ref={this.fixOnOk}
            {...userInsertConfig}
            onVisibleChange={this.onVisibleChange}
          >
            <div className="DatePicker_Children_Special" ref={this.popupDatePicker_wrapComponent}>
              {children &&
                React.isValidElement(children) &&
                React.cloneElement<{extra?: string}>(children, {
                  extra: value ? formatFn(this, value) : this.props.extra || extra,
                })}
            </div>
          </PopupDatePicker>
    )
  }
}



// WEBPACK FOOTER //
// ../src/date-picker/index.tsx